/** Short random id for a newly created pen anchor point. */
export function uid(): string {
  return Math.random().toString(36).slice(2, 10)
}
